export default "__VITE_ASSET__7b42f737__"